import * as React from 'react';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

// tslint:disable-next-line:no-empty-interface
export interface IBigNumberGraphicProps {
    loading: boolean,
    title:string,
    value:any,
}

// tslint:disable-next-line:no-empty-interface
export interface IBigNumberGraphicState {
}

export class BigNumberGraphic extends React.Component<IBigNumberGraphicProps, IBigNumberGraphicState> {

    constructor(props: IBigNumberGraphicProps) {
        super(props);
    }

    public render() {
        return (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="subheading" className="panel-title" component="title">
                    {this.props.title}
                </Typography>
                {this.props.loading ? 
                    <LinearProgress /> : 
                    <Typography component="p" className="big-number">
                        {this.props.value}
                    </Typography>
                }
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/shared/graphics/bigNumbers/BigNumberGraphic.tsx